module.exports = {"开发指南":[{"name":"giud","path":"/giud","desc":"介绍"},{"name":"install","path":"/install","desc":"安装"},{"name":"start","path":"/start","desc":"快速开始"},{"name":"logs","path":"/logs","desc":"更新日志"}],"组件":[{"desc":"基础组件","path":"/component","items":[{"desc":"Table 表格","name":"Table","path":"/Table"}]},{"desc":"函数类","path":"/component","items":[]}]}


//////////////////
// WEBPACK FOOTER
// ./example/nav.config.json
// module id = JhrR
// module chunks = 2